module.exports = __webpack_public_path__ + "static/img/not_found_detail.6f45768.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/not_found_detail.png
// module id = Y2Hb
// module chunks = 37